import {useMemo, useState} from 'react';

export const useSelect = (items) => {

    const [selectedItems, setSelectedItems] = useState([]);
    const selected = useMemo(() => items ? items.filter(item => selectedItems.includes(item.id)) : [], [items, selectedItems])

    function toggle(id) {
        setSelectedItems(items => {
            const index = items.indexOf(id)
            if (index > -1) {
                // Index found, remove it from list
                return [...items.slice(0, index), ...items.slice(index + 1, items.length)]
            } else {
                return [...items, id]
            }
        })
    }

    function clear() {
        setSelectedItems([])
    }

    function isSelected(id) {
        return !!selected.find(item => item.id === id)
    }

    return [selected, toggle, clear, isSelected]
};

export const useSelect2 = () => {
    const [selected, setSelected] = useState([]);

    const toggle = (id) => {
        setSelected(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const isSelected = (id) => selected.includes(id);

    return { selected, toggle, isSelected, setSelected }
};